import { useFetch } from "../lib/useFetch";
import { ts } from "../lib/api";
import { Panel, Spinner } from "./common";
import { BuyButton } from "./ManualBuy";

const WHY = { session_open: "market closed", data_fresh: "price data not fresh", strategy_conditions: "no BUY setup yet", position_size: "size too small", daily_target_lock: "daily target reached", risk_limits: "risk limit reached", max_positions: "2 positions already open", cash_available: "not enough cash" };

export const BuyNowList = () => {
  const { data } = useFetch("/orders/candidates", 120000);
  const rows = data?.rows || [];
  const ready = rows.filter((r) => r.group === "ready");
  const near = rows.filter((r) => r.group === "buyable").sort((a, b) => (b.score || 0) - (a.score || 0)).slice(0, 5);
  const list = ready.length ? ready : near;
  return (
    <Panel title="Boleh beli sekarang" className="mt-3" testid="buy-now-list">
      {!data ? <Spinner /> : (
        <>
          <p className="mb-2 text-[11px] text-slate-600" data-testid="buy-now-summary">
            {ready.length ? `${ready.length} stock(s) have a qualified BUY and fit your cash now.` : "No qualified BUY right now. Closest stocks your cash can buy:"} Checked {ts(data.checked_at)}.
          </p>
          {!list.length ? <p className="text-xs text-slate-500" data-testid="buy-now-empty">Nothing your cash can buy yet. Run “Check now” on Can Buy Now.</p> : (
            <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full">
              <thead><tr><th /><th>Stock</th><th>Signal</th><th>Score</th><th>Lots</th><th>Why not yet</th></tr></thead>
              <tbody>{list.map((r) => (
                <tr key={r.symbol} data-testid={`buy-now-row-${r.symbol}`}>
                  <td><BuyButton symbol={r.symbol} /></td>
                  <td><span className="mono font-semibold">{r.symbol}</span> <span className="text-[10px] text-slate-500">{r.name}</span></td>
                  <td className={`mono font-bold ${r.signal === "BUY" ? "text-emerald-600" : "text-slate-600"}`}>{r.signal}</td>
                  <td className="mono">{r.score}</td><td className="mono">{r.lots ?? "—"}</td>
                  <td className="text-[10px] text-slate-500">{r.approved ? "—" : (r.failed || []).map((x) => WHY[x] || x.replace(/_/g, " ")).join(", ")}</td>
                </tr>))}
              </tbody></table></div>
          )}
        </>
      )}
    </Panel>
  );
};
